module.exports = __webpack_public_path__ + "static/media/plus-icon.2563852a.svg";